import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Fa from 'react-fontawesome';
import DateTimeDisplay from '../../../../../components/date-time-display';

function PublishDateRenderer(props) {
  const { value, data, node } = props;
  const isGrouped = node && node.group;
  if (isGrouped) {
    return null;
  }
  const d = value ? (<DateTimeDisplay value={value} format="short" />) : null;
  let a = d;
  if (data.overview_url) {
    a = (
      <a href={data.overview_url} target="_blank">{d} <Fa name="external-link" /></a>
    );
  }

  return a;
}
PublishDateRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment),
  ]),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  data: PropTypes.shape({
    overview_url: PropTypes.string,
  }),
};
PublishDateRenderer.defaultProps = {
  value: null,
};

export default PublishDateRenderer;
